import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt, faPhone, faUser, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { celularMask, celularMaskInput } from "../../../components/InputTextMask";
import CommonService from "../../../services/CommonService";

export default function FormContato({ contato, handleSalvar, closeModal }) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefones, setTelefones] = useState([{ id_contato_telefone: null, telefone: "" }]);

  useEffect(() => {
    if (contato) {
      setNome(contato.nome || "");
      setEmail(contato.email || "");
      setTelefones(
        contato.telefones?.length
          ? contato.telefones.map((t) => ({
              id_contato_telefone: t.id_contato_telefone,
              telefone: celularMask(t.telefone),
            }))
          : [{ id_contato_telefone: null, telefone: "" }]
      );
    } else {
      setNome("");
      setEmail("");
      setTelefones([{ id_contato_telefone: null, telefone: "" }]);
    }
  }, [contato]);

  const handleTelefoneChange = (index, valor) => {
    const masked = celularMaskInput(valor) || valor;
    setTelefones((prev) =>
      prev.map((t, i) => (i === index ? { ...t, telefone: masked } : t))
    );
  };

  const adicionarTelefone = () => {
    setTelefones((prev) => [...prev, { id_contato_telefone: null, telefone: "" }]);
  };

  const removerTelefone = (index) => {
    setTelefones((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const telefonesValidos = telefones
      .map((t) => ({
        ...t,
        telefone: t.telefone ? CommonService.formatarDeMascaraPhone(t.telefone) : "",
      }))
      .filter((t) => (t.telefone || "").toString().trim() !== "");

    handleSalvar({
      nome,
      email: email || null,
      telefones: telefonesValidos,
    });
  };

  return (
    <Form onSubmit={handleSubmit} className="form-contato">
      <div className="form-secao">
        <div className="form-campo">
          <label className="form-label-icone">
            <FontAwesomeIcon icon={faUser} className="form-label-icon" />
            Nome *
          </label>
          <Form.Control
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
            placeholder="Nome completo do contato"
            className="form-input-custom"
          />
        </div>
        <div className="form-campo">
          <label className="form-label-icone">
            <FontAwesomeIcon icon={faEnvelope} className="form-label-icon" />
            E-mail
          </label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@exemplo.com"
            className="form-input-custom"
          />
        </div>
      </div>
      <div className="form-secao">
        <div className="form-secao-header">
          <span className="form-secao-titulo">
            <FontAwesomeIcon icon={faPhone} className="form-label-icon" />
            Telefones
          </span>
          <button
            type="button"
            className="btn-adicionar-telefone"
            onClick={adicionarTelefone}
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: 5 }} />
            Adicionar
          </button>
        </div>
        <div className="lista-telefones">
          {telefones.map((tel, index) => (
            <div key={index} className="telefone-item">
              <span className="telefone-numero-label">#{index + 1}</span>
              <Form.Control
                type="text"
                value={tel.telefone}
                onChange={(e) => handleTelefoneChange(index, e.target.value)}
                placeholder="(00) 00000-0000"
                className="form-input-custom telefone-input"
              />
              {telefones.length > 1 && (
                <button
                  type="button"
                  className="btn-remover-telefone"
                  onClick={() => removerTelefone(index)}
                  title="Remover telefone"
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="form-rodape">
        <Button variant="outline-secondary" onClick={closeModal} className="btn-cancelar">
          Cancelar
        </Button>
        <Button type="submit" className="btn-salvar">
          Salvar contato
        </Button>
      </div>
    </Form>
  );
}
